/**
 * Splits a filename into basename and extension using the last dot (same rule as upload naming).
 * Does not treat a leading dot as an extension (e.g. ".env" stays base-only).
 */
export function splitFilename(filename: string): { base: string; extension: string } {
	const lastDot = filename.lastIndexOf('.')
	if (lastDot <= 0) {
		return { base: filename, extension: '' }
	}
	return {
		base: filename.slice(0, lastDot),
		extension: filename.slice(lastDot),
	}
}
